import React, { ReactNode } from 'react';
import check from 'assets/PhotoCharter/picto-check-big.png';

interface Props {
  valid?: boolean;
  photo: string;
  text: string | ReactNode;
}

export const PhotoCharterTableRow: React.FC<Props> = ({ valid, photo, text }) => {
  return (
    <tr>
      <td>
        <div>
          <img src={photo} alt="" />
        </div>
      </td>
      <td>
        <div>
          {valid && (
            <span className="check-wrapper">
              <img src={check} alt="" />
            </span>
          )}
          {text}
        </div>
      </td>
    </tr>
  );
};
